import { useAuth0 } from '@auth0/auth0-react';
import { FunctionComponent, useEffect } from 'react';

/**
 * Queries
 */
import { MeQuery, useMeLazyQuery } from '@/graphql/generated';

/**
 * Reactive variables
 */
import { currentUserVar } from '@/apollo/variables';

/**
 * Packages
 */
import { PageLoader } from '@astrumu/ui-library';

interface Props {
  children: (props: {
    currentUser: MeQuery['me'] | null;
  }) => JSX.Element | null;
}

export const UserProvider: FunctionComponent<Props> = ({ children }) => {
  const { isAuthenticated } = useAuth0();

  const [getUser, { data }] = useMeLazyQuery({
    onError: ({ message }) => {
      throw new Error(message);
    },
    onCompleted: ({ me }) => {
      currentUserVar(me);
    }
  });

  useEffect(() => {
    if (isAuthenticated) {
      getUser();
    }
  }, [getUser, isAuthenticated]);

  if (isAuthenticated) {
    if (data) {
      const { me } = data;

      return <>{children({ currentUser: me })}</>;
    }

    return <PageLoader />;
  }

  return <>{children({ currentUser: null })}</>;
};
